module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Copyright © 2005 by Paul A. Offit, M.D."), _c('br'), _vm._v("\nAll rights reserved."), _c('br'), _vm._v("\nThis book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Set in Stemple Garamond type by Keystone Typesetting, Inc."), _c('br'), _vm._v("\nPrinted in the United States of America by R. R. Donnelley & Sons.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("\nOffit, Paul A."), _c('br'), _vm._v("\nThe Cutter incident : how America’s first polio vaccine led to the growing vaccine crisis /"), _c('br'), _vm._v("\nPaul A. Offit."), _c('br'), _vm._v("\np. cm."), _c('br'), _vm._v("\nIncludes bibliographical references and index."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISBN")]), _vm._v(" 0-300-10864-8 (cloth : alk. paper)"), _c('br'), _vm._v("\n1. Poliomyelitis vaccine—History. 2. Poliomyelitis—Vaccination—United States—History."), _c('br'), _vm._v("\n3. Cutter Laboratories. 4. Vaccines—United States. I. Title."), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("QR")]), _vm._v("189.5."), _c('span', {
    staticClass: "small"
  }, [_vm._v("P")]), _vm._v("6"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v("44 2005"), _c('br'), _vm._v("\n614.5′49′0973—dc22"), _c('br'), _vm._v("\n2005040105")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("A catalogue record for this book is available from the British Library.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("The paper in this book meets the guidelines for permanence and durability of the Committee on Production Guidelines for Book Longevity of the Council on Library Resources.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("10   9   8   7   6   5   4   3   2   1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361f7a7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/03copyright.vue
// module id = 63
// module chunks = 0